/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A8Inputs */

const et_faq_a8 = /** @type {(inputs: Faq_A8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müügiprotsessi automatiseerimine algab korduvate tegevuste kaardistamisest. Tavaliselt saab automatiseerida päringute kogumist, esmaseid vastuseid, kliendi kvalifitseerimist, järelkirju, broneeringuid ja CRM-i sisestamist. ScalingWebs aitab luua süsteemi, kus veebileht, AI-vestlusrobot, vormid ja CRM töötavad koos. Nii jõuab müügitiimini paremini ettevalmistatud päring ning ettevõte säästab aega tegevustelt, mida ei pea käsitsi tegema.`)
};

const en_faq_a8 = /** @type {(inputs: Faq_A8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales automation starts with mapping repetitive tasks. Usually, you can automate inquiry capture, initial replies, lead qualification, follow-up emails, bookings, and CRM entry. ScalingWebs helps build a system where your website, AI chatbot, forms, and CRM work together. This delivers better-prepared inquiries to your sales team and saves time on tasks that don't need to be done manually.`)
};

/**
* | output |
* | --- |
* | "Sales automation starts with mapping repetitive tasks. Usually, you can automate inquiry capture, initial replies, lead qualification, follow-up emails, book..." |
*
* @param {Faq_A8Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a8 = /** @type {((inputs?: Faq_A8Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A8Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a8(inputs)
	return en_faq_a8(inputs)
});